import { useUser } from "contexts/UserContext"
import { doc, getFirestore, updateDoc } from "firebase/firestore"
import { useState } from "react";
import { useDocumentData } from "react-firebase-hooks/firestore"
import { SlotSelection } from "./SlotSelection";
import styled from "styled-components";
import { SelectedSlot } from "./SelectedSlot";
import { useQuarterId } from "hooks/UseQuarterId";
import { getFunctions, httpsCallable } from "firebase/functions";


export const TimeSignup = ({ slotsPath, signupsPath, examId, lengthMins = 10 }) => {
  return <TimeSignupOuter>
    <h2>Reserve a Time</h2>
    <TimeSignupInner
      slotsPath={slotsPath}
      signupsPath={signupsPath}
      examId={examId}
      lengthMins={lengthMins}
    />
  </TimeSignupOuter>
}

const TimeSignupInner = ({ slotsPath, signupsPath, examId, lengthMins }) => {
  const db = getFirestore();
  const [slotsData, slotsLoading, slotsError] = useDocumentData(doc(db, slotsPath));
  const [signupsData, signupsLoading, signupsError] = useDocumentData(doc(db, signupsPath));
  const [signupRequestInProgress, setSignupRequestInProgress] = useState(false);

  const user = useUser();
  const userId = user.uid;

  const qtrId = useQuarterId()

  const signupsSafe = signupsData || {}

  if (slotsLoading || signupsLoading) {
    return <></>;
  }

  if (slotsError || signupsError) {
    console.error("slotsError", slotsError);
    console.error("signupsError", signupsError);
    return <p>Error 500</p>;
  }

  const availableSlots = computeAvailibleSlots(slotsData, signupsSafe);
  const selectedSlot = signupsSafe[userId];

  const handleSlotSelection = async (slotId) => {
    const functions = getFunctions();
    try {
      setSignupRequestInProgress(true);

      // No need to manually fetch token — callable functions include auth automatically
      const functions = getFunctions();
      const onSignupRequest = httpsCallable(functions, "onPepSignupRequest");

      // Call the function with your data
      const response = await onSignupRequest({
        qtrId,
        examId,
        slotId,
      });

      console.log("response.data:", response.data);
    } catch (error) {
      console.error("Error updating slot:", error);
    } finally {
      setSignupRequestInProgress(false);
    }
  };

  if (signupRequestInProgress) {
    // return a bootstrap spinner
    return <div className="spinner-grow text-primary" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  }

  if (selectedSlot) {
    return <SelectedSlot
      selectedId={selectedSlot}
      slotsData={slotsData}
      handleSlotSelection={handleSlotSelection}
      lengthMins={lengthMins}
    />
  }

  // if(!editable) {
  //   return <p>Personal Exam Prep have started and the signups are closed. If PEP goes well we will do something similar for the final. </p>
  // }



  return <SlotSelection
    availableSlots={availableSlots}
    handleSlotSelection={handleSlotSelection}
  />
};





const computeAvailibleSlots = (slotsData, signupsData) => {
  // which slotIds are already used?
  const usedSlotIds = new Set(Object.values(signupsData))

  // dictionary from time to each free slotId at that time
  const availibleSlots = {}
  for (const slotId in slotsData) {

    // nobody has claimed this slot yet
    const isAvailable = !usedSlotIds.has(slotId)

    if (isAvailable) {
      const slotData = slotsData[slotId]
      const time = slotData.time
      const date = slotData.date
      const dateTime = `${date} ${time}`
      if (!availibleSlots[dateTime]) {
        availibleSlots[dateTime] = []
      }
      availibleSlots[dateTime].push(slotId)
    }
  }
  return availibleSlots
}

const TimeSignupOuter = styled.div`

  // min-height: 210px;
  // border: 1px solid #ccc;
  // padding: 20px;
  // border-radius: 10px;
  `